export default __webpack_public_path__ + "static/media/017-robin hood.04003776.svg";